"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toDictionary = exports.assertNotNull = exports.map = exports.forEach = exports.values = exports.getKeys = void 0;
/** @returns the non-prototype keys of the given object */
var getKeys = function (obj) {
    return Object.getOwnPropertyNames(obj);
};
exports.getKeys = getKeys;
/**
 * Gets the values of a map as a list
 * @param obj
 * @returns
 */
var values = function (obj) {
    return (0, exports.getKeys)(obj).map(function (key) { return obj[key]; });
};
exports.values = values;
var forEach = function (obj, action) {
    (0, exports.getKeys)(obj).forEach(function (key) { return action(key, obj[key]); });
};
exports.forEach = forEach;
var map = function (obj, mapper) {
    return (0, exports.getKeys)(obj).map(function (key) { return mapper(key, obj[key]); });
};
exports.map = map;
var assertNotNull = function (val, msg) {
    if (val == null) {
        throw new Error(msg);
    }
};
exports.assertNotNull = assertNotNull;
var toDictionary = function (arr, keyMapper, valueMapper) {
    var result = {};
    arr.forEach(function (entry) {
        result[keyMapper(entry)] = valueMapper(entry);
    });
    return result;
};
exports.toDictionary = toDictionary;
//# sourceMappingURL=Utils.js.map